// node_modules
import axios from "axios";
import { LoggingConstants } from "Constants";
// Helpers
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TRequirementDTO } from "Types";

export class RequirementController {
    public async createEmptyRequirementAsync(caseId: number): Promise<number | undefined> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}RequirementCreateEmpty`, {
            caseId: caseId
        });
        
        const formData = new FormData();
        formData.append("CaseID", `${caseId}`);
        formData.append("Modal", "intake");
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Requirement/CreateEmpty`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        if (result.status === 200) {
            return result.data.id;
        } else {
            return undefined;
        }
    }

    public async addRequirement(caseId: number, requirement: TRequirementDTO, fromDelivery: boolean): Promise<TRequirementDTO>  {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}RequirementCreate`, {
            caseId: caseId
        });
        
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/requirements/case/${caseId}`, {
            requirement: requirement,
            fromDelivery: fromDelivery
        });
        return result.data;
    }

    public async changeRequirement(requirementId: number, text: string, fromDelivery: boolean): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}RequirementUpdate`, {
            requirementId: requirementId
        });
        
        const formData = new FormData();
        formData.append("name", text);
        formData.append("fromDelivery", fromDelivery ? "true" : "false");
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/requirements/${requirementId}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.status === 200;
    }

    public async updateRequirementScore(requirementId: number, technologyId: number, score: string, fromDelivery: boolean): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}RequirementChangeScore`, {
            requirementId: requirementId
        });
        
        const result = await axios.post<TRequirementDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/requirements/${requirementId}/technology/${technologyId}`, {
            text: score,
            fromDelivery: fromDelivery
        });
        return result.status === 200;
    }

    public async updateRequirementAsync(caseId: number, requirementId: number, 
            text: string, type: number): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}RequirementUpdateClassic`, {
            requirementId: requirementId
        });

        const formData = new FormData();
        formData.append("ID", `${requirementId}`);
        formData.append("Text", `${text}`);
        formData.append("Type", `${type}`);
        formData.append("CaseID", `${caseId}`);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Requirement/Edit/${requirementId}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } }); 
        return result.status === 200;
    }

    public async deleteRequirementAsync(requirementId: number): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}RequirementDelete`, {
            requirementId: requirementId
        });
        
        const formData = new FormData();
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Requirement/Delete/${requirementId}`,
        formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.status === 200;
    }
}

export const RequirementControllerSingleton = new RequirementController();